// Set the common base URL for your API
const baseURL = process.env.REACT_APP_API_URL; //'http://localhost:3030/';

const MALE = ['avatar-alcides-antonio', 'avatar-cao-yu', 'avatar-carson-darrin',
  'avatar-fran-perez', 'avatar-jie-yan-song', 'avatar-marcus-finn', 'avatar-miron-vitold', 
  'avatar-omar-darboe', 'avatar-penjani-inyene', 'avatar-siegbert-gottfried'];
const FEMALE = ['avatar-anika-visser', 'avatar-chinasa-neo', 'avatar-iulia-albu',
  'avatar-jane-rotanson', 'avatar-nasimiyu-danai', 'avatar-neha-punita', 'avatar-seo-hyeon-ji'];

export const getAvatar = (fileName, gender) => {
  if (fileName) {
    return `${baseURL}img-avatar/${fileName}`;
  }

  const avatarPath = '/assets/avatars/';
  const isFemale = gender === 0;
  const isMale = gender === 1;
  const isLGBT  = gender === 2;

  if (isFemale) {
    const name = FEMALE[Math.floor(Math.random() * FEMALE.length)];
    return `${avatarPath}${name}.png`;
  }

  if (isMale) {
    const name = MALE[Math.floor(Math.random() * MALE.length)];
    return `${avatarPath}${name}.png`;
  }
  
  if(isLGBT){
    // Randomly pick from either male or female
    const isRandomFemale = Math.random() < 0.5;
    const list = isRandomFemale ? FEMALE : MALE;
    const name = list[Math.floor(Math.random() * list.length)];
    return `${avatarPath}${name}.png`;
  }

  return undefined;
};


export const getDat = (fileName) => {
  return `${baseURL}img-asset/${fileName}`;
};

export const getFuel = (fileName) => {
  return `${baseURL}img-fuel/${fileName}`;
};

export const getImg = (filePath) => {
  return `${baseURL}img-file/${filePath}`;
};

export const getThumb = (filePath) => {
  return `${baseURL}img-thumb/${filePath}`;
};
